export default __webpack_public_path__ + "static/media/dashboard-create.53e22f72.svg";